/* Saras Che — scroll reveal (robust). Reveals on load + scroll, with a
   failsafe so content is NEVER left hidden even if events misbehave. */
(function () {
  function init() {
    var sel = '.sc-sec-head,.sc-grid,.sc-cats .cats-grid,.sc-bundle,.sc-story .imgwrap,.sc-story > .sc-wrap > div:last-child,.sc-tst .g3,.sc-insta .g4,.sc-values .row,.sc-news .sc-wrap';
    var els = Array.prototype.slice.call(document.querySelectorAll(sel));
    if (!els.length) return;
    els.forEach(function (e) { e.classList.add('sc-reveal'); });
    function reveal() {
      var h = window.innerHeight || document.documentElement.clientHeight;
      els.forEach(function (e) {
        if (e.classList.contains('sc-in')) return;
        var r = e.getBoundingClientRect();
        if (r.top < h * 0.9 && r.bottom > 0) e.classList.add('sc-in');
      });
    }
    reveal();
    window.addEventListener('scroll', reveal, { passive: true });
    window.addEventListener('resize', reveal);
    setTimeout(reveal, 300);
    // failsafe: never leave anything hidden
    setTimeout(function () { els.forEach(function (e) { e.classList.add('sc-in'); }); }, 2500);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
